/** @format */

import React from 'react';
import { motion } from 'framer-motion';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import { SignInContainer, ButtonsBarContainer } from './sign-in.styles';

import { auth } from '../../firebase/firebase.utils';

import {
  signInStart,
  signOutStart,
  microsoftSignInStart,
} from '../../redux/user/user.actions';

class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const { email, password } = this.state;
    try {
      await auth.signInWithEmailAndPassword(email, password);
      this.setState({ email: '', password: '' });
    } catch (error) {
      console.log(error.message);
    }
  };

  handleChange = (event) => {
    const { value, name } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    return (
      <SignInContainer>
        <ButtonsBarContainer>
          <motion.button
            className="modal-button"
            type="button"
            whileHover={{ scale: 1.1, cursor: 'pointer' }}
            whileTap={{ scale: 0.95 }}
            onClick={
              this.props.currentUser
                ? this.props.signOutStart
                : () => {
                    this.props.signInStart();
                  }
            }
          >
            {this.props.currentUser ? `Sign Out` : `Sign in with Microsoft`}
          </motion.button>

          {/* <motion.button
            className="modal-button"
            type="button"
            whileHover={{ scale: 1.1, cursor: 'pointer' }}
            whileTap={{ scale: 0.95 }}
            onClick={
              this.props.currentUser
                ? this.props.signOutStart
                : () => {
                    this.props.microsoftSignInStart();
                  }
            }
          >
            {this.props.currentUser ? `Sign Out` : `Sign in with Microsoft`}
          </motion.button> */}
        </ButtonsBarContainer>
      </SignInContainer>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  signInStart: () => dispatch(signInStart()),
  signOutStart: () => dispatch(signOutStart()),
  microsoftSignInStart: () => dispatch(microsoftSignInStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
